import { formatCents } from 'utilities/money';

interface LineItem {
  id: string;
  name: string;
  description?: string | null;
  price: number;
}

interface BookingLineItemsProps {
  lineItems: LineItem[];
}

const BookingLineItems = ({ lineItems }: BookingLineItemsProps) => {
  if (lineItems.length === 0) return null;

  const calculateSubtotal = () => {
    return lineItems.reduce((total, item) => total + item.price, 0);
  };

  return (
    <div className="rounded-xl border border-emerald-200/50 bg-emerald-50/50 p-4 sm:p-6">
      <h4 className="mb-4 font-oswald text-base font-bold text-gray-900 sm:text-lg">
        Additional Items
      </h4>

      <div className="space-y-3">
        {lineItems.map((item) => (
          <div
            key={item.id}
            className="flex items-start space-x-3 rounded-lg bg-white/60 p-3"
          >
            <svg
              className="mt-0.5 size-4 shrink-0 text-emerald-600"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
            </svg>
            <div className="flex-1">
              <div className="flex items-start justify-between">
                <div className="pr-2">
                  <p className="font-arimo text-sm font-medium text-gray-900">
                    {item.name}
                  </p>
                  {item.description && (
                    <p className="mt-1 font-arimo text-xs text-gray-600">
                      {item.description}
                    </p>
                  )}
                </div>
                <span className="shrink-0 font-arimo text-sm font-semibold text-gray-900">
                  {formatCents(item.price)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Subtotal */}
      <div className="mt-4 flex items-center justify-between border-t border-emerald-200/50 pt-4">
        <span className="font-arimo text-sm font-medium text-gray-700">
          Additional Items Subtotal:
        </span>
        <span className="font-oswald text-base font-bold text-gray-900 sm:text-lg">
          {formatCents(calculateSubtotal())}
        </span>
      </div>
    </div>
  );
};

export default BookingLineItems;
